module.exports = __webpack_public_path__ + "img/60015.dc07812c.png";